<template lang="html">
  <div id="description-page">
    <section class="breadcrumb-section">
      <div class="container oversized-container">
        <span>Producto</span>
        <span class="line">/</span>
        <span>{{ product.name }}</span>
      </div>
    </section>

    <section class="container med-container description-section" id="product-description">
      <div class="row">

        <div class="col-lg-6 col-gallery" v-if='!icecat'>
          <swiper class="st2" :options="galleryOptions">
            <swiper-slide v-for="(row, galIndex) in gallery" :key="galIndex">
              <div class="image-container">
                <div class="img">
                  <!-- <img :src="row" class="w-100"> -->
                  <v-zoom :img="row" :width="'100%'"></v-zoom>
                </div>
              </div>
            </swiper-slide>

            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>

          <!-- <div class="box-video">
            <iframe src="https://www.youtube.com/embed/yQ_vtTTukq4?si=Aad3F_WR6QZEyEtf" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div> -->
        </div>

        <b-form class="mt-3 mt-lg-0 col-lg-6 col-description" @submit.prevent="quantityValidate()">
          <div class="box-buttons">
            <!-- <button type="button" class="t-150 btn-edit" @click="$refs['modal-edit'].show();"><i class="fa-solid fa-file-pen"></i> PERSONALIZAR</button> -->
          </div>

          <h1 class="mb-2 name set-name">{{ product.name }}</h1>
          <!-- <h4 class="price discount"><span>$ {{ product.price }}</span></h4> -->
          <!-- <h4 class="price f-w-700 old-price">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.oldPrice) }}</h4> -->
          <h4 class="price f-w-600">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }}</h4>

          <div class="box-sets">
            <div class="row row-product" v-for="(s, sInx) in sets" :key="'sInx-'+sInx">
              <div class="col box-product">
                <div class="col col-image">
                  <div class="placed-backg t-150 image" v-bind:style="{ backgroundImage: 'url('+s.imageUrl+')' }" @click="openImageModal(s.imageUrl)">
                    <img src="public/images/pages/sets/product.png">
                  </div>
                </div>

                <div class="col col-text">
                  <h5 class="ex-pr">{{ s.name }}</h5>

                  <span class="t-150 btn-option emb"><i class="fa-regular fa-square-dashed"></i></span>
                  <span class="t-150 btn-option custom"><i class="fa-regular fa-square-check"></i></span>
                  <a class="t-150 btn-option edit" @click="$refs['modal-edit'].show();"><i class="fa-solid fa-pen-to-square"></i></a>
                  <a class="t-150 btn-option info" @click="$refs['modal-info'].show();"><i class="fa-solid fa-info"></i></a>
                </div>
              </div>

              <div class="col box-btns">
                <a class="t-150 btn-delete" @click="deleteProduct(sInx)"><i class="fa-solid fa-xmark"></i></a>
              </div>
            </div>
          </div>

          <h5 class="pt-4 extra-title">Otros productos que puedes agregar</h5>
          <div class="box-sets other-prods">
            <div class="row row-product" v-for="(ep, epInx) in extraProds" :key="'epInx-'+epInx">
              <div class="col box-product">
                <div class="col col-image">
                  <div class="placed-backg t-150 image" v-bind:style="{ backgroundImage: 'url('+ep.imageUrl+')' }" @click="openImageModal(ep.imageUrl)">
                    <img src="public/images/pages/sets/product.png">
                  </div>
                </div>

                <div class="col col-text">
                  <h5>{{ ep.name }}</h5>

                  <a class="t-150 btn-option info" @click="$refs['modal-info'].show();"><i class="fa-solid fa-info"></i></a>
                </div>
              </div>

              <div class="col box-btns">
                <a class="t-150 btn-add" @click="addProduct(epInx)"><i class="fa-solid fa-plus"></i></a>
              </div>
            </div>

            <div class="col-12 text-center" v-if="extraProds.length == 0">
              <h6 class="f-w-600">No hay productos pro agregar</h6>
            </div>
          </div>

          <!-- <div class="mt-1 extra-breadcrumb" v-if="product.ancho">Ancho: {{ product.ancho }} cm</div>
          <div class="mt-1 extra-breadcrumb" v-if="product.alto">Alto: {{ product.alto }} cm</div>
          <div class="mt-1 extra-breadcrumb" v-if="product.largo">Largo: {{ product.largo }} cm</div>
          <div class="mt-1 extra-breadcrumb" v-if="product.volumen">Volumen: {{ product.volumen }}</div>
          <div class="mt-1 extra-breadcrumb" v-if="product.peso">Peso: {{ product.peso }} kg</div>
          <div class="mt-1 extra-breadcrumb" v-if="product.material">Material: {{ product.material }}</div> -->

          <!-- Stock -->
          <!-- <div class="mt-2 extra-breadcrumb">
            <span><strong>Disponibilidad:</strong> En existencias</span>
          </div> -->

          <div class="mt-4 extra-breadcrumb">
            <h6 class="text-center f-w-600 txt-c-3"><i class="fa-solid fa-triangle-exclamation"></i> El set toma un promedio de 2 semanas en fabricarse.</h6>
          </div>

          <!-- <h4 class="pt-2 price f-w-700">Desde $ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }} más IVA</h4> -->

          <!-- <h6 class="mt-4 subtitle">Compartir</h6> -->
          <div class="col-12 mt-1 col-extra col-networks" id="col-extra" v-if="false">
            <div class="row">
              <!-- <div class="col b-print">
                <div class="btn-q" @click="printDiv('product-description')"><span><i class="fas fa-print"></i></span></div>
              </div> -->

              <div class="col px-0 b-sharing">
                <ShareNetwork
                  v-for="(network, pdInx) in networks"
                  :network="network.network"
                  :key="network.network"
                  :style="{backgroundColor: network.color}"
                  :url="sharing.url"
                  :title="sharing.title"
                  :description="sharing.description"
                  :quote="sharing.quote"
                  :hashtags="sharing.hashtags"
                  :twitterUser="sharing.twitterUser">
                  <div class="btn-q"><span><i :class="network.icon"></i></span></div>
                </ShareNetwork>

              </div>

            </div>
          </div>

          <div class="row mt-4 row-quantity-button">
            <!-- <div class="col-12 col-btn-send mb-3">
              <a class="w-100 btn btn-submit c2">DESDE $ <span class="f-w-700">{{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }}</span> MÁS IVA</a>
            </div> -->

            <div class="col-lg col-quantity">
              <h6 class="subtitle" v-if="product.stock">Cantidad</h6>
              <div class="row no-gutters pt-1 box-options" v-if="product.stock">
                <div class="col col-short">
                  <b-form-input v-model="form.quantity" type="number" class="text-center" required></b-form-input>
                </div>
              </div>
            </div>

            <div class="col-lg pl-lg-0 mt-3 mt-lg-2 col-btn-send">
              <b-button type="submit" class="w-100 btn-submit c3">COMPRAR <i class="fa-solid fa-cart-shopping"></i></b-button>
            </div>

            <!-- <div class="col-12 col-btn-send">
              <router-link class="w-100 btn btn-submit c1" to="/contacto">SOLICITAR COTIZACIÓN</router-link>
            </div> -->
          </div>

          <div class="d-block mt-4 mb-2" v-if="product.pdf">
            <a class="btn btn-submit btn-contact" v-if="product.pdf" :href="product.pdf" target="_blank" rel="noopener noreferrer">PDF <i class="fa fa-file-pdf-o"></i></a>
          </div>

          <div class="col-12 my-2">
            <div class="row">
              <div class="col-sm-6 my-2 px-0 pr-sm-3" v-if="product.stock">
                <!-- <b-button type="submit" class="w-100 btn-submit">AGREGAR AL CARRITO <i class="fa-solid fa-cart-shopping"></i></b-button> -->
              </div>

              <div class="col-sm-6 my-2 px-0 pl-sm-3">
                <!-- <router-link class="w-100 btn btn-submit btn-contact" :to="{ name: 'contacto', query: { p: product.name+', SKU: '+product.sku } }">Contactar <i class="far fa-envelope"></i></router-link> -->
              </div>
            </div>
          </div>

          <!-- <h6 class="subtitle">Inventarios</h6>
          <div class="col-12 mt-2 col-extra" id="col-extra">
            <table id="stocktable">
                <tr>
                  <th>Almacen</th>
                  <th>Stock</th>
                </tr>
                <tr v-for="(st,indx) in product.stocks" :key="indx">
                  <td>{{st.warehouse}}</td>
                  <td>{{st.stock}}</td>
                </tr>
            </table>
          </div> -->
        </b-form>

        <!-- <div class="col-12 mb-2">
          <div class="col-12 px-0 col-s-title">
            <h2 class="title">Comentarios</h2>
            <hr class="mt-2 mb-0" />
          </div>
        </div> -->

        <!-- <div class="col-lg-6 col-comment-form">
          <div class="col-12 col-comments">
            <b-form class="box-comment" @submit="addComment">
              <h5 class="subt">Califica este producto</h5>

              <div class="box-stars">
                <b-form-rating inline required v-model="comment.stars" stars="5"></b-form-rating>
              </div>

              <div class="box-input">
                <b-form-textarea v-model="comment.body" placeholder="Escribe tu comentario" required rows="2" max-rows="2"></b-form-textarea>

                <p class="mt-2 text-right">
                  <b-button type="submit" class="btn-co">Comentar</b-button>
                </p>
              </div>
            </b-form>
          </div>
        </div>

        <div class="col-lg-6 mt-3 col-all-comments">
          <div class="wr-comments" v-if="comments.length">
            <div class="row">

              <div class="col-12 col-total-comments" v-if="avg > 0">
                <div class="box"><small>TOTAL:</small> {{ Math.ceil(avg) }}</div>
              </div>

              <div class="col-12 col-comments">
                <div class="row">
                  <div class="col-lg-6 col-comment" v-for="(item, coprInx) in comments" :key="'coprInx-'+coprInx">
                    <div class="box">
                      <div class="box-stars">
                        <b-form-rating v-model="item.star" readonly inline></b-form-rating>
                      </div>

                      <div class="box-comment">{{ item.comment }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-11 mx-auto col-extrainfo" v-if="icecat">
            <div id="Container5"></div>
            <div id="Container7"></div>
            <div id="Container11"></div>
        </div> -->

      </div>

    </section>

    <section class="container med-container related-products-section" id="related-products">
      <div class="row">
        <div class="col-12 px-2 col-s-title">
          <h2 class="text-center title-s1">Otros sets que te pueden gustar</h2>
          <hr class="mt-2 mb-2" />
        </div>
      </div>

      <div class="row">
        <div class="col-12 px-0 col-products">
          <swiper class="swiper carousel-t1" :options="productsOption">
            <swiper-slide v-for="(product, pInx) in products" :key="'pInx-'+pInx">
              <div class="col-12 px-0 sample-product shad-prod">
                <a class="outlined-box">
                  <router-link class="fake-link" :to="'/producto/'+$root._converToURL(product.name, product.id)"></router-link>

                  <div class="box-image">
                    <div class="out-of-stock" v-if="product.stock < 1">Agotado</div>

                    <div class="placed-backg img" v-bind:style="{ backgroundImage: 'url('+product.imageUrl+')' }">
                      <img src="public/images/pages/products/product.png" >
                    </div>
                  </div>

                  <div class="box-shot-descr">
                    <h6 class="brand">{{ product.sku }}</h6>
                    <h6 class="name">{{ product.name }}</h6>
                    <div class="b-type">
                      <div class="type s1">SET DE 5 PIEZAS</div>
                    </div>
                    <!-- <h6 class="brand">{{ product.brand }}</h6> -->
                    <!-- <h6 class="price discount"><span>$ {{ product.price }}</span></h6> -->
                    <h6 class="price">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }} USD</h6>
                  </div>

                  <cart-component :product="product"></cart-component>
                </a>
              </div>
            </swiper-slide>

            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
      </div>
    </section>

    <sweet-modal :icon="modal.icon" :blocking="modal.block" :hide-close-button="modal.block"  ref="modal">
      <div v-html="modal.msg"></div>
      <div class="col-12 text-center" style="padding-top: 20px;" v-if="modal.icon == 'success'">
        <b-button class="btn btn-primary" slot="button" v-on:click.prevent="$refs.modal.close()">Agregar mas productos</b-button>
        <b-button class="btn btn-primary" slot="button" v-on:click.prevent="$refs.modal.close(); $router.push('/cart')">Ir al carrito <i class="color-white fas fa-shopping-cart"></i></b-button>
      </div>
    </sweet-modal>

    <!-- Modal imagen -->
    <b-modal modal-class="modal-st1" ref="modal-image" size="lg" title="" centered hide-footer no-close-on-backdrop no-close-on-esc>
      <img class="w-100" :src="imageModal">
    </b-modal>

    <b-modal modal-class="modal-st1" ref="modal-edit" size="lg" title="" centered hide-footer no-close-on-backdrop no-close-on-esc>
      <div class="box-edit">
        <div class="col-lg-5 col-products">
          <div class="box">
            <h6 class="title">Artículo a personalizar</h6>

            <div class="b-opts" style="pointer-events: none;">
              <div class="opt" v-bind:class="{ active : editForm.product == 1 }" @click="editProduct(1)">
                <h6>Cojín</h6>
              </div>

              <div class="opt" v-bind:class="{ active : editForm.product == 2 }" @click="editProduct(2)">
                <h6>Almohadas</h6>
              </div>

              <div class="opt" v-bind:class="{ active : editForm.product == 3 }" @click="editProduct(3)">
                <h6>Biblia</h6>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-7 col-image">
          <img :src="editForm.imageUrl">
        </div>

        <div class="col-12 col-options">
          <hr class="mt-0" />

          <b-form class="box" @submit="onSubmitEdit">
            <div class="col-sm-6 col-lg-4 col-opt pl-0 pr-0 pr-sm-2">
              <b-form-group class="custom-f-group" label="Ocasión">
                <b-form-select v-model="editForm.ocasion">
                  <b-form-select-option :value="null"></b-form-select-option>
                  <b-form-select-option value="1">Opción 1</b-form-select-option>
                  <b-form-select-option value="2">Opción 2</b-form-select-option>
                </b-form-select>
              </b-form-group>
            </div>

            <div class="col-lg-8"></div>

            <div class="col-sm-6 col-lg-4 col-special-select pl-0 pr-0 pr-sm-2">
              <b-form-group class="custom-f-group mb-0" label="Estilo">
              </b-form-group>

              <b-dropdown variant="link">
                <template #button-content>
                  <div v-if="editForm.estilo == null"></div>
                  <div v-else>
                    <div class="img" v-bind:style="{ backgroundImage: 'url('+editForm.estilo.imageUrl+')' }"></div> <div class="text">{{ editForm.estilo.text }}</div>
                  </div>
                </template>
                <b-dropdown-item v-for="(e, eInx) in estilos" :key="'eInx-'+eInx" @click="editForm.estilo = e">
                  <div class="col img" v-bind:style="{ backgroundImage: 'url('+e.imageUrl+')' }"></div>
                  <div class="col text">{{ e.text }}</div>
                </b-dropdown-item>
              </b-dropdown>
            </div>

            <div class="col-sm-6 col-lg-4 col-opt pl-0 pl-sm-2 pr-0 pr-lg-2">
              <b-form-group class="custom-f-group" label="Color de fondo">
                <b-form-select v-model="editForm.mfondo">
                  <b-form-select-option :value="null"></b-form-select-option>
                  <b-form-select-option value="1">Opción 1</b-form-select-option>
                  <b-form-select-option value="2">Opción 2</b-form-select-option>
                </b-form-select>
              </b-form-group>
            </div>

            <div class="col-sm-6 col-lg-4 col-opt pl-0 pl-lg-2 pr-0 pr-sm-2 pr-lg-0">
              <b-form-group class="custom-f-group" label="Color de adorno">
                <b-form-select v-model="editForm.madorno">
                  <b-form-select-option :value="null"></b-form-select-option>
                  <b-form-select-option value="1">Opción 1</b-form-select-option>
                  <b-form-select-option value="2">Opción 2</b-form-select-option>
                </b-form-select>
              </b-form-group>
            </div>

            <div class="col-sm-6 col-lg-4 col-special-select pl-0 pl-sm-2 pl-lg-0 pr-0 pr-lg-2">
              <b-form-group class="custom-f-group mb-0" label="Bordado">
              </b-form-group>

              <b-dropdown variant="link">
                <template #button-content>
                  <div v-if="editForm.bordado == null"></div>
                  <div v-else>
                    <div class="img" v-bind:style="{ backgroundImage: 'url('+editForm.bordado.imageUrl+')' }"></div> <div class="text">{{ editForm.bordado.text }}</div>
                  </div>
                </template>
                <b-dropdown-item v-for="(b, bInx) in bordados" :key="'bInx-'+bInx" @click="editForm.bordado = b">
                  <div class="col img" v-bind:style="{ backgroundImage: 'url('+b.imageUrl+')' }"></div>
                  <div class="col text">{{ b.text }}</div>
                </b-dropdown-item>
              </b-dropdown>
            </div>

            <div class="col-sm-6 col-lg-4 col-special-select pl-0 pl-lg-2 pr-0 pr-sm-2">
              <b-form-group class="custom-f-group mb-0" label="Color de bordado">
              </b-form-group>

              <b-dropdown variant="link">
                <template #button-content>
                  <div v-if="editForm.color == null"></div>
                  <div v-else>
                    <div class="img" v-bind:style="{ backgroundColor: editForm.color.hex }"></div> <div class="text">{{ editForm.color.text }}</div>
                  </div>
                </template>
                <b-dropdown-item v-for="(c, cInx) in colors" :key="'cInx-'+cInx" @click="editForm.color = c">
                  <div class="col img" v-bind:style="{ backgroundColor: c.hex }"></div>
                  <div class="col text">{{ c.text }}</div>
                </b-dropdown-item>
              </b-dropdown>
            </div>

            <div class="col-sm-6 col-lg-4"></div>

            <div class="col-sm-6 col-lg-4 col-opt pl-0 pr-0 pr-sm-2">
              <b-form-group class="custom-f-group" label="Grabado de nombre">
                <b-form-input v-model="editForm.nombre" placeholder=""></b-form-input>
              </b-form-group>
            </div>

            <div class="col-sm-6 col-lg-4 col-opt pl-0 pl-sm-2 pr-0 pr-lg-2">
              <b-form-group class="custom-f-group" label="Fecha">
                <b-form-input v-model="editForm.fecha" placeholder=""></b-form-input>
              </b-form-group>
            </div>

            <div class="col-12 col-lg-4 col-button">
              <b-button class="btn-edit" type="submit">Aplicar</b-button>
            </div>
          </b-form>
        </div>
      </div>
    </b-modal>

    <b-modal modal-class="modal-st1" ref="modal-info" title="" size="sm" centered hide-footer no-close-on-backdrop no-close-on-esc>
      <div class="col-12 px-4 py-4 text-center">
        <h4 class="text-center f-w-600 px-4">Medidas</h4>
        <p>
          <strong class="f-w-600">Ancho: </strong> 15.50 cm
        </p>
        <p>
          <strong class="f-w-600">Alto: </strong> 6.30 cm
        </p>
        <p>
          <strong class="f-w-600">Largo: </strong> 15.50 cm
        </p>

        <h4 class="text-center f-w-600 px-4 mt-2">Peso</h4>
        <p class="text-center">
          0.47 grs.
        </p>
      </div>
    </b-modal>

  </div>
</template>

<script>
import vZoom from 'vue-zoom'; // https://www.npmjs.com/package/vue-zoom
export default {
  components: {vZoom},

  data() {
    return {
      id: null,

      form: {
        quantity: 1,
        color: null,
        bordado: null,
        tipografia: null,
        extras: [],
      },

      editForm: {
        product: 1,
        imageUrl: 'public/images/pages/sets/set-1.jpg',
        estilo: null,
        bordado: null,
        color: null,
      },

      gallery: [
        'public/images/pages/sets/product-6.jpg',
        'public/images/pages/sets/product-6.jpg',
      ],

      product: {
        id: 2,
        name: 'SET 7 PIEZAS',
        sku: '63423',
        category_id: '5',
        category: 'Utencilios',
        subcategory_id: '5',
        subcategory: 'Baterías de cocina',
        price: '75',
        oldPrice: '0',
        marca_id: 1,
        marca: 'Gibson ',
        description: '<p>Hermosa corona elaborada en plata con piedras y cristales de diferentes formas y figuras  en color tornasol, añade un toque magico y especial con nuestra hermosa corona diseñada especificamente para adaptarse a cualquier tipo de peinado.</p>',
        stock: 35,
        ancho: 15,
        alto: 9,
        largo: 15,
        peso: 0.05,
        stocks:[],
      },
      estilos: [
        { id: 1, imageUrl: 'public/images/pages/products/img-select-1.png', text: 'Centro' },
        { id: 2, imageUrl: 'public/images/pages/products/img-select-1.png', text: 'Opción 2' },
        { id: 3, imageUrl: 'public/images/pages/products/img-select-1.png', text: 'Opción 3' },
      ],
      bordados: [
        { id: 1, imageUrl: 'public/images/pages/products/img-select-2.png', text: 'Bordado 1' },
        { id: 2, imageUrl: 'public/images/pages/products/img-select-2.png', text: 'Bordado 2' },
        { id: 3, imageUrl: 'public/images/pages/products/img-select-2.png', text: 'Bordado 3' },
      ],
      category: [],
      products: [
        {
          "id": 1,
          "sku": "63423",
          "name": "SET DE COJINES Y ROSAS",
          "price": "890.00",
          "stock": 5,
          "imageUrl": "public/images/pages/sets/product-1.jpg"
        },
        {
          "id": 2,
          "sku": "59227",
          "name": "SET CON COLCHONES, FLORES Y BIBLIA",
          "price": "1290.00",
          "stock": 15,
          "imageUrl": "public/images/pages/sets/product-2.jpg",
        },
        {
          "id": 3,
          "sku": "66720",
          "name": "SET DE BIBLIA Y DOS ALMOHADAS",
          "price": "780.00",
          "stock": 9,
          "imageUrl": "public/images/pages/sets/product-3.jpg"
        },
        {
          "id": 4,
          "sku": "59223",
          "name": "SET DE 7 PIEZAS CON ALMOHADAS, FLORES Y BIBLIA",
          "price": "999.00",
          "stock": 6,
          "imageUrl": "public/images/pages/sets/product-4.jpg"
        },
      ],
      sizes: [],
      size: [],
      stock: 0,
      avg: 0,
      favorite: false,
      icecat: false,

      // == Sharing ==
      sharing: {
        url: 'https://xvshopping.online/#/producto/',
        title: 'XV Shopping',
        description: 'Esto es un ejemplo de descripción',
        quote: 'Esto es el Quote',
        hashtags: 'this,isthe,hashtag',
        twitterUser: 'twitter'
      },

      networks: [
        { network: 'twitter', name: 'Twitter', icon: 'fa-brands fa-x-twitter' },
        { network: 'facebook', name: 'Facebook', icon: 'fab fa-facebook-f' },
        { network: 'email', name: 'Email', icon: 'fas fa-envelope' },
        { network: 'whatsapp', name: 'WhatsApp', icon: 'fab fa-whatsapp' },
      ],
      // == ==

      colors: [
        { id: 14, hex: '#df8f13', text: 'Oro' },
        { id: 1, hex: '#ffffff', text: 'Blanco' },
        { id: 2, hex: '#b6b3b3', text: 'Gris' },
        { id: 5, hex: '#151414', text: 'Negro' },
        { id: 6, hex: '#ff0184', text: 'Rosa' },
        { id: 10, hex: '#9008b6', text: 'Púrpura' },
        { id: 11, hex: '#44079d', text: 'Azul marino' },
        { id: 13, hex: '#2295e9', text: 'Azul' },
      ],

      sets: [
        { imageUrl: 'public/images/pages/sets/set-1.jpg', name: '1 Biblia' },
        { imageUrl: 'public/images/pages/sets/set-2.jpg', name: '1 Ramo de rosas' },
        { imageUrl: 'public/images/pages/sets/set-1.jpg', name: '2 Almohadas' },
        { imageUrl: 'public/images/pages/sets/set-2.jpg', name: '3 Cojines' },
      ],

      extraProds:  [
        { imageUrl: 'public/images/pages/sets/set-2.jpg', name: '1 Producto extra' },
        { imageUrl: 'public/images/pages/sets/set-2.jpg', name: 'Otro producto mas' },
        { imageUrl: 'public/images/pages/sets/set-1.jpg', name: 'Un producto mas' },
      ],

      relatedProducts: [],

      comments: [],

      modal:{
        msg:'',
        icon:'',
        block:false
      },

      imageModal: null,

      comment:{
        stars: null,
        body: ''
      },

      // == Carrusel options ==
      galleryOptions: {
        loop: false,
        speed: 600,

        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },

        // autoplay: {
        //   delay: 3000,
        //   disableOnInteraction: false
        // }
      },

      productsOption: {
        loop: true,
        slidesPerView: 4,
        spaceBetween: 4,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        breakpoints: {
          1200: {
            spaceBetween: 0,
            slidesPerView: 4
          },
          992: {
            spaceBetween: 0,
            slidesPerView: 3
          },
          768: {
            spaceBetween: 0,
            slidesPerView: 2
          },
          1: {
            slidesPerView: 1
          },
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        effect: 'slide',
        speed: 600
      },
      // == ==
    }
  },

  watch: {
    "$route.params.id" : function(v){
      //this.id = this.$route.params.id;
      this.id = this.$root._getURLID(this.$route.params.id);
      this.getProduct();
    }
  },

  methods:{
    toast(title, msg, variant) {
      this.$bvToast.toast(msg, {
        title: title,
        toaster: 'b-toaster-bottom-right',
        variant: variant,
        solid: true,
        appendToast: true
      })
    },

    copyLink(value) {
      navigator.clipboard.writeText(value);
      // alert('Link copiado');
      this.toast('Pago seguro ', 'Link copiado correctamente', 'success');
    },

    deleteProduct(idx) {
      this.sets.splice(idx, 1);
    },

    addProduct(idx) {
      this.sets.unshift(this.extraProds[idx]);
      this.extraProds.splice(idx, 1);
    },

    getComments(id){
      axios.get(tools.url('/api/comments/'+id)).then((response)=>{
        this.comments = response.data.comments;
        this.avg = response.data.avg;

      }).catch((error)=>{
        console.log(error);
      })
    },

    addComment: function(){
      axios.post(tools.url("/api/comments/"+this.product.id),{stars:this.comment.stars, comment:this.comment.body}).then((response) => {
        this.comment.stars = null;
        this.comment.body = '';
        this.getComments(this.id);
      }).catch((error) => {
        alert("Error al agregar comentario");
        console.log(error);
      })
    },

    quantityValidate(){
      if(this.form.quantity > this.product.stock){
        if(this.product.stock <= 1){ w = 'pieza' };
        this.toast('Error', 'Este artículo cuenta con maximo '+this.product.stock+' '+w+' en existencia', 'danger');
      }else{
        this.stock = this.product.stock;
        this.addCart();
      }
    },

    getProduct(){
      axios.get(tools.url('/api/products/' + this.id)).then((response)=>{
        this.product = [];
        this.gallery = [];
        this.product = response.data;
        this.category = response.data.category;
        this.gallery = response.data.gallery;

        if(this.product.stock > 0){
          this.form.quantity = 1;
        }

        this.getRelated(this.product.id);
        //this.getComments(this.product.id);
      }).catch((error)=>{
        console.log(error);
      });
    },

    addCart(){
      var cart = [];
      var encontrado = false;

      if(this.form.quantity > 0){
          if(localStorage.cart){
            cart = JSON.parse(localStorage.getItem('cart'));

            for(var i = 0; i < cart.length ; i++){
              if(cart[i].id == this.id){
                var suma = Number(cart[i].quantity) + Number(this.form.quantity);
                cart[i].quantity = suma <= this.stock ? suma : this.stock;
                encontrado = true;
                break;
              }
            }

            if(!encontrado){
              cart.push({ id:this.id, quantity:this.form.quantity });
            }
          } else{
            cart.push({ id:this.id, quantity:this.form.quantity });
          }

          localStorage.setItem("cart",JSON.stringify(cart));
          this.$root.cartCount = cart.length;
          this.modal.msg = 'El producto <b>'+this.product.name+'</b> se agregado al carrito con '+this.form.quantity+' piezas';
          this.modal.icon = 'success';
          this.$refs.modal.open();
      }

    },

    getRelated(id){
      axios.get(tools.url('/api/products/related/'+id)).then((response)=>{
        this.products = response.data;
      }).catch((error)=>{
        console.log(error);
      })
    },

    getFavorite: function(){
        if(this.$root.user.id){
            axios.post(tools.url('/api/favorite'),{ product_id: this.id }).then((response)=>{
                if(response.data == 'true'){
                    this.favorite = true;
                }else{
                    this.favorite = false;
                }
                this.favoritesCount();
            }).catch((error)=>{
                console.log(error);
            });
        }
    },

    addFavorite: function(){
        if(this.$root.user.id){
            axios.post(tools.url('/api/addFavorite'),{product_id: this.id }).then((response)=>{
                this.favorite = response.data.favorite;
                this.favoritesCount();
            }).catch((error)=>{
                console.log(error);
            });
        }
    },

    favoritesCount: function(){
        if(this.$root.user.id){
            axios.get(tools.url('/api/favoritesCount')).then((response)=>{
                this.$root.favoriteCount = response.data;
            }).catch((error)=>{
                console.log(error);
            })
        }
    },

    editProduct(id) {
      let images = [
        'public/images/pages/sets/set-1.jpg',
        'public/images/pages/sets/set-2.jpg',
        'public/images/pages/sets/set-1.jpg',
      ];

      this.editForm.product = id;
      this.editForm.imageUrl = images[id-1];
    },

    openImageModal(img) {
      this.imageModal = img;

      this.$refs['modal-image'].show();
    },

    onSubmitEdit(event) {
      event.preventDefault();
      this.$refs['modal-edit'].hide();
    },
  },

  mounted(){
    this.id = this.$route.params.id;
    this.id = this.$root._getURLID(this.$route.params.id);
    // this.getProduct();

    /*if(this.$root.logged == true){
        this.getFavorite();
    }*/
  }
}
</script>
<style>
#stocktable table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#stocktable td {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
#stocktable th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
  background-color: #dddddd;
}
</style>
